import * as _ from 'lodash';
import qs from 'qs';
import b64url from 'base64-url';
import axios from 'axios';
import {
    CIG_SSO,
    OCI_SSO,
    CIG_AUTH_PARAMS,
    REST_API,
    LOG_SERVER_KEY,
    UILOG_MAX_MESSAGE_LENGTH,
    REPORTING_APP_ID,
    CREATING_TENANT_COOKIE_PREFIX,
    DEFAULT_CREATING_TENANT_COOKIE_MAXAGE,
    AUTH0_COUNTRY_CODE,
    AUTH0_META_DATA,
    TENANT_LOCATION_LOCK, AUTH0,
    ERROR_REQUEST_ID_SAFE,
    ERROR_REQUEST_ID_MAX_LENGTH,
    UI_MODE
} from './constants'

export const DROPDOWN_MENU_HEIGHTS = {
    DASHBOARD_WIDGET_EDITOR : 146,
    AUTOCOMPLETE_MENU_HEIGHT: 204,
    REACT_WINDOW_LIST_MENU: 170,
    BY_OBJECT_BLOCK_HEIGHT: 178, // this is the height of sub-menu in groupBy block.
    DROPDOWN_ROW_HEIGHT: 32.09,
    PARTIAL_VIEW_HEIGHT: 14
};

export function isElementInView(container, element) {
    if (!container || !element) {
        return false;
    }
    // get container properties
    const cTop = _.get(container.getClientRects(), '[0].top', 0);
    const cBottom = _.get(container.getClientRects(), '[0].bottom', 0);

    // get element properties
    const eTop = _.get(element.getClientRects(), '[0].top', 0);
    const eBottom = _.get(element.getClientRects(), '[0].bottom', 0);

    // check if in view
    const isInView = (eTop >= cTop && eBottom <= cBottom);
    // console.log(`isInView = (eTop >= cTop && eBottom <= cBottom) = ${isInView} = (${eTop} >= ${cTop} && ${eBottom} <= ${cBottom})`);

    return isInView;
}

export function scrollItemIntoView(containerClass, elementClass) {
    // it is okay to not scroll into view if there are exceptional cases such as element not
    // rendered in case of react-window or the menu is not rendered yet etc.,
    try {
        const container = document.getElementsByClassName(containerClass)[0];
        const element = document.getElementsByClassName(elementClass)[0];
        // console.log("TCL: scrollItemIntoView -> container, element", containerClass, elementClass)
        if (element && !isElementInView(container, element)) {
            element.scrollIntoView(false);
        }
    }
    catch (e) {
        // console.log("TCL: scrollItemIntoView -> e", e)
    } // eslint-disable-line
}

export function isCookieExisted(cookieName, rawCookies='') {
    if (_.isEmpty(cookieName) || _.isNil(cookieName)) {
        return false;
    }
    let cookies = [];
    if (_.isEmpty(rawCookies)) {
        cookies = document.cookie.split('; ');
    }
    else {
        cookies = rawCookies.split('; ');
    }

    const ck = _.filter(cookies, function(ck) {
        return _.includes(ck, cookieName);
    });

    return ck.length > 0;
}

export function setTenantCreationCookie(userInfo, expiredInSecond=-1) { //default 10 minutes
    const cookieName = genCookieNameById(userInfo.subject, CREATING_TENANT_COOKIE_PREFIX),
        cookieValue = { iss: Date.now() },
        base64CookieValue = jsonToBase64String(cookieValue, false),
        maxAgeInSeconds = expiredInSecond >= 0 ? expiredInSecond : DEFAULT_CREATING_TENANT_COOKIE_MAXAGE; // 10 minutes

    setCookie(cookieName, base64CookieValue, maxAgeInSeconds);
}

export function genCookieNameById(userId, prefix) {
    if (_.isEmpty(userId) || _.isEmpty(prefix)) {
        return '';
    }
    return prefix + b64url.encode(userId);
}

export function removeTenantLocationLock() {
    // eslint-disable-next-line  security/detect-object-injection
    if (!_.isNil(sessionStorage[TENANT_LOCATION_LOCK])) {
        sessionStorage.removeItem(TENANT_LOCATION_LOCK);
    }
}

export function removeLoginCookie() {
    const queryParams = getQueryString();
    if (_.includes(queryParams, CIG_SSO.cookiesKey) && _.includes(window.location.pathname, '/login/tenantnav')) {
        try {
            const queryObject = getJsonQueryString(queryParams);
            if (!_.isEmpty(queryObject[CIG_SSO.cookiesKey])) {
                removeCookie(queryObject[CIG_SSO.cookiesKey]);
            }
        }
        catch (e) {
            /* istanbul ignore next */
            window.CIG_LOG.debug('Gateway: Fail to remove login cookie');
        }
    }
}

export function jsonToBase64String(json, uriEncoding) {
    try {
        let jsonStr = JSON.stringify(json);
        if (uriEncoding)
            jsonStr = window.encodeURIComponent(jsonStr);

        return window.btoa(jsonStr);
    }
    catch (e) {
        /* istanbul ignore next */
        return '';
    }
}

export function base64ToJson(base64Str, uriDecoding) {
    try {
        let jsonStr = window.atob(base64Str);
        if (uriDecoding)
            jsonStr = window.decodeURIComponent(jsonStr);

        return JSON.parse(jsonStr);
    }
    catch (e) {
        /* istanbul ignore next */
        return {};
    }
}

export function getCookie(rawCookies='', cname) {
    if (_.isEmpty(cname))
        return '';

    const name = cname + '=',
        cookies = _.isUndefined(rawCookies) || _.isEmpty(rawCookies) ? document.cookie : rawCookies,
        ca = cookies.split(';');

    for(let i = 0; i < ca.length; i++) {
        let c = ca[parseInt(i)];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            try {
                return window.decodeURIComponent(c.substring(name.length, c.length));
            }
            catch (e) {
                return c.substring(name.length, c.length)
            }
        }
    }
    return '';
}

// Careful when using this function.
// TenantId string is not exact matched: Ex: notenantId, tenantIdAbc will return cookie value instead of false.
export function verifyCookieContainTenantId(rawCookies='', cookieName) {
    const ck = getCookie(rawCookies, _.isUndefined(cookieName) ? getQueryStringParam(CIG_SSO.cookiesKey) : cookieName);
    if (!_.isEmpty(ck)) {
        const ckdecode = cigDecode(ck);
        return _.includes(ckdecode, CIG_SSO.tenantId) ? ck : false;
    }
    return false;
}

// maxAgeInSeconds: cookie lifetime in seconds
//     -1: session expiration
export function setCookie(cookieName, cookieValue, maxAgeInSeconds=-1, domain, path='/', sameSite='Strict', isSecure) {

    let cookie = cookieName + '=' + cookieValue;
    if (maxAgeInSeconds > 0) {
        cookie = cookie + ';max-age=' + maxAgeInSeconds;

        //Cover Internet Explorer and Microsoft Edge. No need to set expiration date for Edge 16+
        let d = new Date();
        //const currentd = d.toUTCString();
        d.setTime(d.getTime() + (maxAgeInSeconds * 1000));
        const expires = ((d === 0) ? 0 : d.toUTCString());
        cookie = cookie + ';expires=' + expires;
        //window.CIG_LOG.debug('Gateway: current: ' + currentd + ' expiration: ' + expires);
    }
    if (!_.isEmpty(domain)) {
        cookie = cookie + ';domain='+ domain;
    }
    cookie = cookie + ';path=' + path;
    if (!_.isNil(isSecure)) {
        cookie = cookie + ';Secure=' + isSecure;
    }
    if (!_.isNull(sameSite))
        cookie = cookie + ';SameSite=' + sameSite;
    else
        cookie = cookie + ';SameSite=Strict';

    document.cookie = cookie;
}

export function removeCookie(cookieName) {
    const cookies = document.cookie.split('; ');
    const cookie = _.filter(cookies, function(ck) {
        const ckValue = _.split(ck, '=');
        return _.isEmpty(ckValue[0]) ? false : ckValue[0] === cookieName;
    });
    if (!_.isEmpty(cookie)) {
        let d = new Date();
        d.setTime(d.getTime() - (5 * 60 * 1000));
        document.cookie = cookieName + '=;Max-Age=-99999999;expires=' + d.toUTCString() + ';path=/;';
        return true;
    }
    return false;
}

export function cigDecode(str) {
    try {
        return window.atob(str);
    }
    catch (e) {
        return str;
    }
}

export function getQueryString(urlHref) {
    return _.isUndefined(urlHref) || _.isEmpty(urlHref) ? window.location.href.split('?')[1] : urlHref.split('?')[1];
}

export function transformUtmQueryString(urlHref) {
    const urlQs = getQueryString(urlHref);
    if (_.includes(urlQs, 'utm_')) {
        const queryStr = urlQs.replace(/\?/g, '').split('&');
        const marketInfo = _.filter(queryStr, (o) => _.includes(o, 'utm_') || _.startsWith(o,'explicitOptIn=') ||
            _.startsWith(o,'state=') || _.startsWith(o,'marketingOptIn='));

        return '?' + _.trimStart(_.join(marketInfo, '&'), '&');
    }
    return _.isNil(urlQs) ? '' : urlQs;
}

export function getJsonQueryString(urlQueryStr) {  // Paramater must be a string
    //const qs = _.isUndefined(urlQueryStr) ? window.location.search.substring(1) : urlQueryStr;
    const urlQs = (_.isUndefined(urlQueryStr) || _.isNull(urlQueryStr)) ? getQueryString(window.location.href) : urlQueryStr;
    if (_.isUndefined(urlQs) || _.isNull(urlQs)) {
        return false;
    }

    const queryStr = urlQs.replace(/\?/g,'').split('&');
    let qsObj = _.reduce(queryStr, function(result, item) {
        const x = item.split('=');
        if (x.length > 1) {
            const key = _.trim(x[0]);
            const value = _.trim(x[1]);
            try {
                result[key.toString()] = _.isEmpty(value) ? value : decodeURIComponent(value);
            }
            catch (e) {
                result[key.toString()]= value;
            }
        }
        return result;
    }, {});
    return qsObj;
}

export function verifyRedirectionQuery(urlQueryStr) { //Paramater must be string
    if (!_.isEmpty(urlQueryStr)) {
        //const qsKeys = Object.keys(qsObj);
        // const x = _.sortedUniq(qsParams);
        // const k = _.sortedUniq(qsKeys)
        // return JSON.stringify(x) === JSON.stringify(k);
        const qsObj = getJsonQueryString(urlQueryStr);
        return Object.prototype.hasOwnProperty.call(qsObj, CIG_SSO.tenantId);
    }
    /* istanbul ignore next */
    return false;
}

// This function will
// 1. Append the query param if key does not exist in query param string. Value can not be undefined.
// 2. Replace the query param if key is existed in query param string. Value can not be undefined.
//    if value is null, it will replace with empty string.
// 3. Remove the query param if key is existed in query param string and value is undefined.
// 4. The return URI will be undefined if there is no query param string in existed URL and provided query param value is undefined.
// 5. This function will not work if fragment mark '#' before query string mark '?'. Rule: RFC_3986
export function updateQueryStringParam(uri, key, value) {
    value = _.isNull(value) ? '' : value;
    // eslint-disable-next-line  security/detect-non-literal-regexp
    const re = new RegExp('([?&])' + key + '=.*?(&|#|$)', 'i');
    if( _.isUndefined(value) ) {
        if (uri.match(re)) {
            uri = uri.replace(re, '$1$2');
            if (/\?&#|\?&$/.test(uri)) {
                return uri.replace(/\?&/,'');
            }
            if (/\?#|\?$/.test(uri)) {
                return uri.replace(/\?/,'');
            }
            return uri.replace('&&', '&');
        }
    }
    else {
        if (uri.match(re)) {
            if (_.isEmpty(key)) {
                return uri.replace(re, '$1' + value + '$2');
            }
            return uri.replace(re, '$1' + key + '=' + value + '$2');
        }
        else {
            let hash =  '';
            if( uri.indexOf('#') !== -1 ){
                hash = uri.replace(/.*#/, '#');
                uri = uri.replace(/#.*/, '');
            }
            const separator = uri.indexOf('?') !== -1 ? '&' : '?';
            if (_.isEmpty(key)) {
                return uri + separator + value + hash;
            }
            uri = uri + separator + key + '=' + value + hash;
            return uri.replace(/&&/g, '&').replace(/\?&/, '?');
        }
    }
}

export function getQueryStringParam(key, queryStr) {
    const searchParam = _.isUndefined(queryStr) ? window.location.search : queryStr;
    const parsed = qs.parse(searchParam,  { ignoreQueryPrefix: true });
    return _.get(parsed, key) || '';
}

export function randomString(length) {
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for(let i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
}

export function sendRedirectWithForm(uri, tenantId, site, redirect, productType = 'CI', applicationId) {
    var form = document.createElement('form');
    document.body.appendChild(form);

    form.method = 'POST';
    form.action = window.location.origin + uri;

    const tenantEle = document.createElement('INPUT');
    tenantEle.setAttribute('name', 'tenantId');
    tenantEle.setAttribute('value', tenantId);
    tenantEle.setAttribute('type', 'hidden');
    form.appendChild(tenantEle);

    const redirectEle = document.createElement('INPUT');
    redirectEle.setAttribute('name', 'redirect');
    redirectEle.setAttribute('value', redirect ? redirect : '');
    redirectEle.setAttribute('type', 'hidden');
    form.appendChild(redirectEle);

    const siteEle = document.createElement('INPUT');
    siteEle.setAttribute('name', 'site');
    siteEle.setAttribute('value', _.isEmpty(site) ? window.location.hostname : site);
    siteEle.setAttribute('type', 'hidden');
    form.appendChild(siteEle);

    const productTypeEle = document.createElement('INPUT');
    productTypeEle.setAttribute('name', 'productType');
    productTypeEle.setAttribute('value', _.isEmpty(productType) ? 'CI' : productType);
    productTypeEle.setAttribute('type', 'hidden');
    form.appendChild(productTypeEle);

    if (!_.isEmpty(applicationId)) {
        const applicationIdEle = document.createElement('INPUT');
        applicationIdEle.setAttribute('name', 'productType');
        applicationIdEle.setAttribute('value', applicationId);
        applicationIdEle.setAttribute('type', 'hidden');
        form.appendChild(applicationIdEle);
    }

    const forceEle = document.createElement('INPUT');
    forceEle.setAttribute('name', 'force');
    forceEle.setAttribute('value', tenantId === '00000000-0000-0000-0000-000000000000' ? 'true' : 'false');
    forceEle.setAttribute('type', 'hidden');
    form.appendChild(forceEle);

    form.setAttribute('target', '_self');
    form.submit();
}

/* istanbul ignore next */
export function ociConnection(myWindow, tenantName, tenantToken, relativePath, appId) {
    const randKey = getQueryStringParam(CIG_SSO.randomKey) || randomString(10);
    const page = updateQueryStringParam(window.location.href, CIG_SSO.randomKey, undefined);
    window.history.replaceState({cighs: randKey}, null, page);

    const form = myWindow.document.createElement('form');
    myWindow.document.body.appendChild(form);

    let jwtFieldName;
    let redirectFieldName;

    if (appId === REPORTING_APP_ID) {
        jwtFieldName = 'code';
        redirectFieldName = 'state';
    }
    else {
        jwtFieldName = 'jwt';
        redirectFieldName = 'redirect';
    }

    form.method = 'POST';
    form.action = 'https://' + tenantName + (appId === REPORTING_APP_ID ? OCI_SSO.reportingApi : OCI_SSO.ssoApi);

    const jwtEle = myWindow.document.createElement('INPUT');
    jwtEle.setAttribute('name', jwtFieldName);
    jwtEle.setAttribute('value', tenantToken);
    jwtEle.setAttribute('type', 'hidden');
    form.appendChild(jwtEle);

    const redirectEle = myWindow.document.createElement('INPUT');
    redirectEle.setAttribute('name', redirectFieldName);
    redirectEle.setAttribute('value', relativePath);
    redirectEle.setAttribute('type', 'hidden');
    form.appendChild(redirectEle);

    form.setAttribute('target', '_self');
    form.submit();
    myWindow.document.body.removeChild(form);
}

/**
 *  check logout url
 *       /?logout=
 */
export function isServiceLogoutUri() {
    return _.includes(window.location.search, CIG_SSO.logout) && !isLogoutUri();
}

export function isLogoutUri() {
    return window.location.pathname === '/logout/tenant' || window.location.pathname === '/logout/csecure';
}

/* istanbul ignore next */
export function isSkipAwsRefreshSSO() {
    return window.auth.isTokenExisted() || window.location.pathname === '/callback' || window.location.pathname === '/error/auth' ||
         isLogoutUri() || isServiceLogoutUri();
}

export function isServiceCmUri() {
    return window.location.pathname === '/service/cm' || window.location.pathname === '/service/cm/';
}

export function isDev() {
    return window.CIG.mode === 'DEV';
}

export function getCigUIPath() {
    let navPath = window.location.pathname.replace(/\/$/, '') || '/service';
    let uiPath = {};
    const cookieValues = verifyCookieContainTenantId();

    uiPath[CIG_AUTH_PARAMS.pathName] = navPath;
    if (cookieValues) {
        uiPath[CIG_AUTH_PARAMS.queryStr] = cookieValues;
    }
    else {
        const querystr = getQueryString(window.location.href);
        // Query string includes access token, try to get the CIG_AUTH_PARAMS.queryStr from state
        // and assign to uiPath.
        if (_.includes(querystr,'#access_token')) {
            const urlQuery = getJsonQueryString(window.location.href);
            const state = _.get(urlQuery, 'state', '');
            if (!_.isEmpty(state)) {
                const jsonObj = base64ToJson(state, true);
                uiPath[CIG_AUTH_PARAMS.queryStr] = _.get(jsonObj, CIG_AUTH_PARAMS.queryStr, '');
                uiPath[CIG_AUTH_PARAMS.pathName] = _.get(jsonObj, CIG_AUTH_PARAMS.pathName, '/service');
            }
            else {
                // If query string has access token and state does not contain query string, set it to empty to reduce URL length.
                uiPath[CIG_AUTH_PARAMS.queryStr] = '';
            }
        }
        else {
            uiPath[CIG_AUTH_PARAMS.queryStr] = querystr;
        }

    }
    return uiPath;
}

export function isDigits(value) {
    return /^[0-9]*$/.test(value);
}

export function processUiLogData(data) {
    if (!Object.prototype.hasOwnProperty.call(data,'key')) {
        data.key = LOG_SERVER_KEY;
    }
    if (!_.isNil(data.logMessage) && !_.isEmpty(data.logMessage) && data.logMessage.length > UILOG_MAX_MESSAGE_LENGTH) {
        data.logMessage = _.truncate(data.logMessage, { length: UILOG_MAX_MESSAGE_LENGTH });
    }
    return data;
}

export function getAuthAccessToken(tokenOrAuthObject) {
    if (_.isEmpty(tokenOrAuthObject)) {
        return getCookie('', CIG_SSO.cookieJWT);
    }
    if (_.isString(tokenOrAuthObject)) {
        return tokenOrAuthObject;
    }
    const token = tokenOrAuthObject.getAccessToken();
    return _.isEmpty(token) ? getCookie('', CIG_SSO.cookieJWT) : token;
}

/* istanbul ignore next */
export function serverLog(tokenOrAuthObject, data) {
    const headers = getAuthorizedHeader(tokenOrAuthObject);

    if (_.isEmpty(headers)) {
        window.CIG_LOG.error('Gateway: serverLog - missing access token');
    }

    const log = processUiLogData(data);
    const URI = REST_API + '/ui/uilog';

    axios
        .post(URI, log, { headers })
        .then(() => {
            window.CIG_LOG.debug('Gateway: serverLog - server log message: ' + JSON.stringify(log));
        })
        .catch(function(err) {
            window.CIG_LOG.error('Gateway: serverLog - server log failed: ' + err);
        });
}

/* istanbul ignore next */
export async function asyncServerLog(tokenOrAuthObject, data) {
    const log = processUiLogData(data);

    const headers = getAuthorizedHeader(tokenOrAuthObject);
    const URI = REST_API + '/ui/uilog';
    await axios
        .post(URI, log, { headers })
        .then(() => {
            window.CIG_LOG.debug('Gateway: asyncServerLog - server log message: ' + JSON.stringify(log));
        })
        .catch(function(err) {
            window.CIG_LOG.debug('Gateway: asyncServerLog - server log message: ' + JSON.stringify(log));
            window.CIG_LOG.error('Gateway: asyncServerLog - server log fail: ' + err);
        });
}

export function getAuth0UserProfilePhone(userProfile) {
    /* istanbul ignore next */
    if (_.isNil(userProfile)) {
        return null;
    }
    const metaData = _.get(userProfile, AUTH0_META_DATA);
    if (!_.isNil(metaData)) {
        return  _.get(metaData, 'phone');
    }
    /* istanbul ignore next */
    return null;
}

//TODO: May not need to return US
export function getAuth0UserProfileCountryCode(userProfile) {
    if (_.isNil(userProfile)) {
        return 'US';
    }
    const geoCountryCode = _.get(userProfile, AUTH0_COUNTRY_CODE, 'US');
    return _.isNil(geoCountryCode) || _.isEmpty(geoCountryCode) ? 'US' : geoCountryCode;
}

export function getLoginSignupInfoFromQueryString(queryParams) {
    const json = getJsonQueryString(decodeURIComponent(queryParams));

    const firstName = _.get(json, 'firstName', '').trim();
    const lastName =  _.get(json, 'lastName', '').trim();
    const name = _.trim(firstName + ' ' + lastName);
    const email =  _.get(json, 'email', '').trim();
    const company = _.get(json, 'company', '').trim();
    const phone = _.get(json, 'phone', '').trim();

    let startOnSignup = _.get(json, 'startOnSignup', false);
    startOnSignup = startOnSignup === 'false' ? false : startOnSignup;
    startOnSignup = startOnSignup === 'true' ? true : startOnSignup;

    if (startOnSignup !== true && startOnSignup !== false) {
        startOnSignup = false;
    }

    return {
        'name': name,
        'email': email,
        'company': company,
        'phone': phone,
        'startOnSignup': startOnSignup,
    }
}

export function verifyNetAppDomain(fullDomainName, hasProtocol= false) {
    try {
        if (!_.isEmpty(fullDomainName)) {
            const url = new URL(hasProtocol ? fullDomainName : 'https://' + fullDomainName);
            return /\.netapp\.com$/.test(url.origin) || /\.netapp-sec\.com$/.test(url.origin);
        }
    }
    catch (e) {
        /* istanbul ignore next */
        window.CIG_LOG.error('Failed to verify domain name');
    }
    return false;
}

export function validateEncodeRedirectPath(redirectPath) {
    if (_.isEmpty(redirectPath))
        return true;

    try {
        return /^[\x20-\x7F]*$/.test(redirectPath);
    }
    catch (e) {
        /* istanbul ignore next */
        window.CIG_LOG.error('Failed to decoding redirect path');
    }
    /* istanbul ignore next */
    return false;
}

export const getAuthorizedHeader = (auth) => {
    let headers = {};
    const token = getAuthAccessToken(auth);
    if (!_.isEmpty(token)) {
        headers = {'Authorization': `Bearer ${token}`};
    }
    return headers;
}

export const getCloudHomeUrl = (cloudHomeUrl) => {
    return getNetAppConsoleUrl(cloudHomeUrl, _.isEmpty(cloudHomeUrl) ? '/home' : undefined);
}

export const getNetAppConsoleUrl = (cloudHomeUrl, path) => {
    if (!_.isEmpty(cloudHomeUrl))
        return cloudHomeUrl + (_.isEmpty(path) ? '' : path);

    if (!_.isNil(window.CIG) && window.CIG.authProvider === AUTH0) {
        return window.CIG['blueXPConfig'].serviceUrl + ( _.isEmpty(path) ? '' : path);
    }
    else {
        return '#';
    }
}

export function validateUiMode(uiMode) {
    if (_.isEmpty(uiMode)) {
        return false;
    }
    const upperCaseUiMode = _.toUpper(uiMode);
    return upperCaseUiMode === UI_MODE.STANDALONE_MODE || upperCaseUiMode === UI_MODE.CM_MODE ||
        upperCaseUiMode === UI_MODE.TENANT_TYPE_CI || upperCaseUiMode === UI_MODE.TENANT_TYPE_ONTAP ||
        upperCaseUiMode === UI_MODE.TENANT_TYPE_CS;
}

export function isStaging() {
    return _.includes(_.get(window, 'CIG.authConfig.domain', ''), 'staging-netapp');
}

export function isStandaloneMode() {
    return _.get(window,'CIG.standaloneMode', false) === true;
}

export function shouldRedirectToNetAppConsole() {
    return _.get(window, 'CIG.productType') === 'DSP'
        || _.get(window, 'CIG.standaloneMode') === false;
}

export function redirectToNetAppConsoleHome() {
    const consoleUrl = _.get(window, 'CIG.netAppConsoleUrl');
    if (_.isEmpty(consoleUrl)) {
        return false;
    }
    window.location.replace(`${consoleUrl}/home`);
    return true;
}

/**
 * Returns a sanitized request/correlation id for UI and logging (trimmed, safe charset, max length), or '' if unusable.
 * @param {Object} errProps - Props or error object that may contain `requestId`.
 * @returns {string}
 */
export function getErrorRequestIdAsString(errProps) {
    const raw = _.trim(_.toString(_.get(errProps, 'requestId')));
    if (_.isEmpty(raw)) {
        return '';
    }
    const sanitized = _.replace(raw, ERROR_REQUEST_ID_SAFE, '');
    return _.truncate(sanitized, {
        length: ERROR_REQUEST_ID_MAX_LENGTH,
        omission: '',
    });
}
